import { Component } from '@angular/core';

@Component({
  selector: 'app-promotion-icon',
  imports: [],
  templateUrl: './promotion-icon.html',
  styleUrl: './promotion-icon.css'
})
export class PromotionIcon {

}
